import React from 'react'
import PropTypes from 'prop-types'
import { Wrapper, ImgPreview } from './SliderElementsStyledComponents'

function ImageThumbnail ({ url, onClick, vertical, id, ...rest }) {
  return (
    <Wrapper onClick={onClick} {...rest} vertical={vertical}>
      <ImgPreview id={`social-${id}`} vertical={vertical} url={url} />
    </Wrapper>
  )
}

ImageThumbnail.displayName = 'ImageThumbnail'

ImageThumbnail.propTypes = {
  url: PropTypes.string,
  onClick: PropTypes.func,
  vertical: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default ImageThumbnail
